import IAuditoria from "../entities/IAuditoria";
import { IDesactivarRegistro } from "../entities/ILogMantenedor";
import IReporteSabana from "../entities/IReporteSabana";
import { deleteAPI, getAPI, getAPIBlob, postAPI } from "../helpers/httpHelper";
import {
  API_AUDITORIA,
  API_AUDITORIA_GETBLOB_GETEXCELALLPLANESHISTORICO,
  API_AUDITORIA_GETBLOB_GETEXCELREPORTESABANA,
  API_AUDITORIA_GET_CONTENIDODOCUMENTOAUDITORIA,
  API_AUDITORIA_GET_DOCUMENTOSAUDITORIA,
  API_AUDITORIA_POST_GENERARPDFINFORME,
  API_AUDITORIA_POST_GENERARPDFPLAN,
  API_AUDITORIA_POST_GENERARPDFPROGRAMAANUAL,
  API_DESVIACION_DELETE_ELIMINARAUDITORIA,
  API_DESVIACION_DELETE_ELIMINARAUDITORIAIN,
  API_DESVIACION_POST_DESACTIVARAUDITORIA,
  API_DESVIACION_POST_DESACTIVARAUDITORIAIN,
  ROW_COUNT_MAX,
} from "../helpers/variableHelper";

export default class AuditoriaService {
  public static GetContenidoArchivo = async (token: string, ruta: string) => {
    try {
      let r = await getAPIBlob(
        `${API_AUDITORIA}${API_AUDITORIA_GET_CONTENIDODOCUMENTOAUDITORIA}`,
        { Authorization: `Bearer ${token}` },
        {
          RUTA: ruta,
        }
      );
      let file = r.result;
      let fileURL = URL.createObjectURL(file);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.download = ruta.split("/")?.pop() || ruta;
      fileLink.click();
      return true;
    } catch (error) {
      return false;
    }
  };

  public static ExportExcelHistorico = async (token: string, filters: Partial<IAuditoria>) => {
    try {
      let r = await getAPIBlob(
        `${API_AUDITORIA}${API_AUDITORIA_GETBLOB_GETEXCELALLPLANESHISTORICO}`,
        { Authorization: `Bearer ${token}` },
        { ...filters, ORDENADOPOR: "ID", ORIENTACION: "DESC", PAGINA: 1, PAGINADO: ROW_COUNT_MAX }
      );
      let file = r.result;
      let fileURL = URL.createObjectURL(file);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.download = "Reporte Histórico Auditoría.xlsx";
      fileLink.click();
    } catch (error) {
      return false;
    }
  };

  public static ExportExcelReporteSabana = async (token: string, filters: Partial<IReporteSabana>) => {
    try {
      let r = await getAPIBlob(
        `${API_AUDITORIA}${API_AUDITORIA_GETBLOB_GETEXCELREPORTESABANA}`,
        { Authorization: `Bearer ${token}` },
        { ...filters, ORDENADOPOR: `AU."ID"`, ORIENTACION: "DESC", PAGINA: 1, PAGINADO: ROW_COUNT_MAX }
      );
      let file = r.result;
      let fileURL = URL.createObjectURL(file);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.download = "Reporte sábana de auditoría.xlsx";
      fileLink.click();
    } catch (error) {
      return false;
    }
  };
  public static GenerarPDFPrograma = async (token: string, idPrograma: number) => {
    postAPI(
      `${API_AUDITORIA}${API_AUDITORIA_POST_GENERARPDFPROGRAMAANUAL}`,
      {
        ID: idPrograma,
      },
      {
        Authorization: `Bearer ${token}`,
      }
    ).catch((e) => console.log(e));
  };
  public static GenerarPDFPlan = async (token: string, idAuditoria: number) => {
    postAPI(
      `${API_AUDITORIA}${API_AUDITORIA_POST_GENERARPDFPLAN}`,
      {
        ID: idAuditoria,
      },
      {
        Authorization: `Bearer ${token}`,
      }
    ).catch((e) => console.log(e));
  };
  public static GenerarPDFInforme = async (token: string, idAuditoria: number) => {
    postAPI(
      `${API_AUDITORIA}${API_AUDITORIA_POST_GENERARPDFINFORME}`,
      {
        ID: idAuditoria,
      },
      {
        Authorization: `Bearer ${token}`,
      }
    ).catch((e) => console.log(e));
  };
  public static ObtenerDocumentos = async (token: string, params: any) => {
    try {
      let resultDocumentosAuditoria = (
        await getAPI(`${API_AUDITORIA}${API_AUDITORIA_GET_DOCUMENTOSAUDITORIA}`, { Authorization: `Bearer ${token}` }, params)
      ).result;
      return resultDocumentosAuditoria;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  };

  public static async desactivarRegistroAuditoria(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await postAPI(`${API_AUDITORIA}${API_DESVIACION_POST_DESACTIVARAUDITORIA}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async eliminarRegistroAuditoria(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await deleteAPI(
        `${API_AUDITORIA}${API_DESVIACION_DELETE_ELIMINARAUDITORIA}`,
        {
          Authorization: `Bearer ${token}`,
        },
        value
      );
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async desactivarRegistroAuditoriaIN(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await postAPI(`${API_AUDITORIA}${API_DESVIACION_POST_DESACTIVARAUDITORIAIN}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async eliminarRegistroAuditoriaIN(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await deleteAPI(
        `${API_AUDITORIA}${API_DESVIACION_DELETE_ELIMINARAUDITORIAIN}`,
        {
          Authorization: `Bearer ${token}`,
        },
        value
      );
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }
}
